<template>
  <!-- 内容管理-投保流程 -->
  <div>
    <Modal v-model="visible" :title="isEdit ? '编辑' : '新增'" width="1000px" :footer-hide="true" :mask-closable="false" class="my-modal">
      <Form ref="form" :model="formData" class="page-form" :label-width="80" v-if="visible">
        <FormItem label="标题" class="full" prop="name" :rules="$units.formRule.required('请输入标题')">
          <Select v-model="formData.name" placeholder="请选择标题" class="input">
            <Option v-for="text in typeList" :key="text" :value="text"> {{ text }} </Option>
          </Select>
        </FormItem>
        <FormItem label="介绍" prop="content" class="full" :rules="$units.formRule.required('请输入介绍')">
          <editor ref="editorRef" v-model="formData.content" :toolbar="editorToolbar" :showFullScreen="false"></editor>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import editor from '@/components/commons/editor';
export default {
  components: {
    editor
  },
  props: {
    type: null, // upstream:上游 downstream:下游
    tableData: null, //所有结算规则
    productForm: null //产品信息
  },
  data() {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      editIndex: '',
      typeList: ['首期结算规则', '续期结算规则', '其他规则'],
      editorToolbar: ['bold'],
      formData: {}
    };
  },
  mounted() {},
  methods: {
    open(data, editIndex, isEdit) {
      const hasTypeList = this.tableData.map(item => item.name);
      const typeList = ['首期结算规则', '续期结算规则', '其他规则'];
      this.typeList = typeList.filter(text => !hasTypeList.includes(text));// 可新增的类型
      if (this.typeList.length == 0 && !isEdit) {
        this.$notice.msg('没有可以继续新增的规则类型');
        return;
      }
      this.isEdit = isEdit;
      this.editIndex = editIndex;
      this.formData = JSON.parse(JSON.stringify(data));
      if (isEdit) {
        this.title = '编辑';
        // 编辑时选项列表不存在当前类型时添加当前类型
        if(!this.typeList.includes(data.name)) {
          this.typeList.push(data.name)
        }
      } else {
        this.title = '新增';
        this.$set(this.formData, 'name', this.typeList[0]);
      }
      this.visible = true;
    },
    //图片上传
    upLoadImg(file, key) {
      if (!file) {
        this.formData[key] = '';
        this.$refs.form.validateField(key);
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData).then(res => {
        this.formData[key] = res.data[0].path;
        this.$refs.form.validateField(key);
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = {
            name: this.formData.name,
            content: this.formData.content
          };
          data.content = data.content
            .replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/g, '')
            .replace(/size\s*?=\s*?([‘"])[\s\S]*?\1/g, '')
            .replace(/<p/g, '<p style="font-size: 14px"');
          let list = [];
          if (this.editIndex == 'add') {
            list = this.tableData.concat(data);
          } else {
            list = JSON.parse(JSON.stringify(this.tableData));
            list[this.editIndex] = data;
          }
          let ajaxConfig;
          if (this.type == 'upstream') {
            ajaxConfig = {
              url: '/buz/productBase/updateSettleRule',
              type: 'POST',
              data: {
                id: this.productForm.id,
                settleRule: list
              }
            };
          } else {
            ajaxConfig = {
              url: '/buz/productBase/updateSubSettleRule',
              type: 'POST',
              data: {
                productCode: this.productForm.productCode,
                subordinateSettleRule: list
              }
            };
          }
          this.$http(ajaxConfig).then(res => {
            this.$emit('success', list);
            this.visible = false;
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body .page-form {
    z-index: 3;
  }
}
.input {
  &:nth-child(1) {
    width: 140px;
  }
  &:nth-child(2) {
    width: 400px;
    margin-left: 15px;
  }
}
/deep/ .editor {
  margin-bottom: 30px;
  .w-e-toolbar {
    z-index: 10 !important;
  }
  .w-e-text-container {
    height: 150px !important;
    z-index: 1 !important;
  }
  .w-e-text {
    min-height: 150px !important;
  }
}
</style>